export default {

  init() {

    const resultsContainer = document.querySelector('.searchwp-live-search-results');
    if (resultsContainer) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            document.documentElement.classList.add('no-scroll');
            document.body.classList.add('no-scroll');
          } else if (mutation.removedNodes.length > 0) {
            document.documentElement.classList.remove('no-scroll');
            document.body.classList.remove('no-scroll');
          }
        });
      });

      observer.observe(resultsContainer, { childList: true, subtree: true });
    } else {
      console.error('Results container not found');
    }



    $('.hamburger').on('click', function() {
      $(this).toggleClass('is-active');
      $('.top-bar').toggleClass('open');
    });

    var urlParams = new URLSearchParams(window.location.search);
    var reset = urlParams.get('psr');

    if(reset) {
      if(reset == 'bar') {
        $('#modalPassReset').foundation('open');
      }
    }

    if (urlParams.get("login") === "show") {
      $('#modalLogin').foundation('open');
    }

    // Slick Slider

    $('.success__story_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.slider-nav',
    });
    $('.slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.success__story_slider',
      dots: false,
      arrows: true,
      centerMode: false,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="slick-custom-arrow slick-prev" aria-label="Previous slide"><svg width="38" height="34" viewBox="0 0 38 34" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect x="38" y="34" width="38" height="34" transform="rotate(-180 38 34)" fill="url(#pattern0_936_3140)"/><defs><pattern id="pattern0_936_3140" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_936_3140" transform="scale(0.0263158 0.0294118)"/></pattern><image id="image0_936_3140" width="38" height="34" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAiCAYAAAAzrKu4AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAIgAAAABxcoabAAABeUlEQVRYCcXYPU7DMBQH8L9D2omhU8WYgYGNHqEbN2hH6Ek4QsUJyFaVDhwBZljoCTrTDhUrqTDPqI4eCCn+thc7/no/OZZsGQictg8YbZe49p1W+E7Ax+8XqJoTbI519XCCGW+3KRc2nbv6EmrA+tzQ6t2zb6tiUBit0BtFv2MCZ1zQX6lBtMdqiF/7zPq3RoEpoC8uGswXFxXmg4sOc8UlgbngksFscUlhNrjkMFNcFpgJLhusCyd2K4yl/Dk+KtU5eZK4oOPrTMeVwEu/hyvxvsRGCFS6IUtOGsK1SQosCvr+aGtyFRhKEYovvJa9PsaHA0aZTKe0jeYU+1zHp8W7HU4x/2PVzfHz/SMGTYMnisQXZUZ3ulpFzwLrQmWBmaCSw0xRSWE2qGQwW1QSmAsqOswVFRXmg4oG80VFgYVAKVjQJwI1YfOJZ8r+PWZUu2kKClN3OzrkLlnw9uxjdUbFoLCypEcVifUxsjPKSO7SSb2TuYzjY74B5JejwZguLggAAAAASUVORK5CYII="/></defs></svg></button>',
      nextArrow: '<button type="button" class="slick-custom-arrow slick-next" aria-label="Next slide"><svg width="38" height="34" viewBox="0 0 38 34" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect width="38" height="34" fill="url(#pattern0_936_3139)"/><defs><pattern id="pattern0_936_3139" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_936_3139" transform="scale(0.0263158 0.0294118)"/></pattern><image id="image0_936_3139" width="38" height="34" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAiCAYAAAAzrKu4AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAIgAAAABxcoabAAABeUlEQVRYCcXYPU7DMBQH8L9D2omhU8WYgYGNHqEbN2hH6Ek4QsUJyFaVDhwBZljoCTrTDhUrqTDPqI4eCCn+thc7/no/OZZsGQictg8YbZe49p1W+E7Ax+8XqJoTbI519XCCGW+3KRc2nbv6EmrA+tzQ6t2zb6tiUBit0BtFv2MCZ1zQX6lBtMdqiF/7zPq3RoEpoC8uGswXFxXmg4sOc8UlgbngksFscUlhNrjkMFNcFpgJLhusCyd2K4yl/Dk+KtU5eZK4oOPrTMeVwEu/hyvxvsRGCFS6IUtOGsK1SQosCvr+aGtyFRhKEYovvJa9PsaHA0aZTKe0jeYU+1zHp8W7HU4x/2PVzfHz/SMGTYMnisQXZUZ3ulpFzwLrQmWBmaCSw0xRSWE2qGQwW1QSmAsqOswVFRXmg4oG80VFgYVAKVjQJwI1YfOJZ8r+PWZUu2kKClN3OzrkLlnw9uxjdUbFoLCypEcVifUxsjPKSO7SSb2TuYzjY74B5JejwZguLggAAAAASUVORK5CYII="/></defs></svg></button>',
      responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      ],
    });


    $('.modalSwap').on('click', function (event) {
      event.preventDefault();
      let type = $(this).data('type');

      if (type === 'create') {
        $('#modalLogin').foundation('close');
        $('#modalNewPlatinum').foundation('open');
      } else {
        $('#modalLogin').foundation('open');
        $('#modalNewPlatinum').foundation('close');
      }
    });

    // Fire Interests Modal if URL param is present.
    // URL Param is ONLY added on registration
    // Cleans up URL after Modal is engaged

    if (urlParams.has('show_interests')) {
      const modal = $('#modalTopics');
      if (modal.length) {
        modal.foundation('open');
        // Remove the URL parameter
        const newUrl = window.location.origin + window.location.pathname;
        history.replaceState(null, '', newUrl);
      } else {
        console.error('Areas of Interest Modal not found');
      }
    }

    // Get full login key and value from URL
    // Needed for failed login attempts only
    function getUrlParameter(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    if (getUrlParameter('login') === 'failed') {
      var modal = $('#modalLogin');
      modal.foundation('open');
    }

    if (getUrlParameter('login') === 'empty') {
      var modal = $('#modalLogin');
      modal.foundation('open');
    }


    // User Meta Form Submission Handler

    $('#user-meta-form').on('submit', function(e) {
      const submitButton = document.querySelector('.buttonSubmit');
      submitButton.classList.add('submitting');
      e.preventDefault();

      // Gather form data
      var formData = {
        action: 'update_user_meta',
        first_name: $('#first_name').val(),
        last_name: $('#last_name').val(),
        law_firm: $('#law_firm').val(),
        security: user_meta_form.nonce, // Nonce for security
      };

      // AJAX request to update user meta
      $.post(user_meta_form.ajax_url, formData, function(response) {
        submitButton.classList.remove('submitting');
          $('#form-message').text(response.message); // Show success or error message
        });
    });

    // Favorites

    $(document).on('click', '.add-to-list', function(event) {
      let id = $(this).data('sid');
      let action;
      const elm = $(this);

      if ($(this).hasClass('is-favorite')) {
        action = 'remove_from_favorites'
      } else {
        action = 'add_to_favorites'
      }
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action: action,
          sid: id,
        },
        success: function (response) {
          if (action === 'remove_from_favorites') {
            elm.removeClass('is-favorite');
          } else {
            elm.addClass('is-favorite');
          }
        },
        error: function (errorThrown) {
          console.log(errorThrown);
        },
      });

      event.preventDefault();
    });

    // Authentication Logic


    /* Registration Form Functions */
    var typingTimer,
    doneTypingInterval = 500,
    topics = [],
    format = [],
    order = 'DESC';

    function password_strength() {
      var strength = {
        0: "Worst",
        1: "Bad",
        2: "Weak",
        3: "Good",
        4: "Strong",
      };

      var val = $('input[name="pass"]').val();
      var result = zxcvbn(val);

      // Update the password strength meter
      $('#password-strength-meter').attr('data-strength', result.score);

      // Update the text indicator
      var $strengthText = $('#password-strength-text'); // Cache the text indicator
      if (val !== "") {
        $strengthText.html("Strength: " + strength[result.score]).addClass('active');

        // Set the color based on the score
        switch (result.score) {
          case 0:
          case 1:
          case 2:
            $strengthText.css('color', 'red'); // Red for Worst, Bad, Weak
            break;
            case 3:
            $strengthText.css('color', 'orange'); // Orange for Good
            break;
            case 4:
            $strengthText.css('color', 'green'); // Green for Strong
            break;
          }
        } else {
        $strengthText.html("").removeClass('active').css('color', ''); // Reset color and text
      }
    }

    function password_check() {
      if ($('input[name="pass"]').val() !== $('input[name="confirmpass"]').val()) {
        $('#password-match-text').html("Passwords do not match!");
        $('#password-match-text:not(.active)').addClass('active');
      } else {
        $('#password-match-text').html("").removeClass('active');
      }
    }

    $(document).on('keyup', '#registrationForm input[name="pass"]', function(e){
      clearTimeout(typingTimer);
      console.log($(this).val());
      typingTimer = setTimeout(password_strength, doneTypingInterval);
    });

    $(document).on('keydown', '#registrationForm input[name="pass"]', function(e){
      clearTimeout(typingTimer);
    });

    $(document).on('keyup', '#form-reset-password input[name="pass"]', function(e){
      clearTimeout(typingTimer);
      console.log($(this).val());
      typingTimer = setTimeout(password_strength, doneTypingInterval);
    });

    $(document).on('keydown', '#form-reset-password input[name="pass"]', function(e){
      clearTimeout(typingTimer);
      $('#errorMessages').html('');
    });

    $(document).on('keyup', '#form-reset-password input[name="confirmpass"]', function(e){
      clearTimeout(typingTimer);
      typingTimer = setTimeout(password_check, doneTypingInterval);
    });

    $(document).on('keydown', 'input[name="confirmpass"]', function(e){
      clearTimeout(typingTimer);
    });

      // Validate password rules
      function validatePasswordReset(pass, confirm, container) {

        // Clear previous error messages
        container.html('');

        // Regular expression for password validation
        const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{6,}$/;

        // Check if the password matches the criteria
        if (!passwordRegex.test(pass)) {
          container.append('Password must be at least 6 characters long, include one uppercase letter, and one symbol.');
          return false; // Validation failed
        }

        // Validation passed
        container.append('Password is valid!');
        return true; // Validation succeeded
      }

      function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      function validate_registration(form, consent) {
        var valid = true;

        // Clear previous error classes
        form.find('input.error').removeClass('error');

        // Check required fields
        form.find('input[data-req="true"]').each(function(e) {
          if (!$(this).val() || $(this).val() == '') {
            $(this).addClass('error');
            $(this).parent().find('.error-text').html('Required');
            valid = false;
          }
        });

        // Validate email
        var email = form.find('input[name="email"]').val();
        if (!validateEmail(email)) {
          form.find('input[name="email"]').addClass('error');
          form.find('input[name="email"]').parent().find('.error-text').html('Please enter a valid email address');
          valid = false;
        }

        // Validate consent checkbox if required
        if (consent) {
          if (!form.find('input[name="consent"]').is(':checked')) {
            form.find('input[name="consent"]').addClass('error');
            form.find('input[name="consent"]').parent().find('.error-text').html('Please consent to the above');
            valid = false;
          } else {
            form.find('input[name="consent"]').parent().find('.error-text').html('');
          }
        }

        return valid;
      }      


    //Pass in jquery form and last input field of form
    function enterOnSubmit(form, input){
      input.keypress(function (e){
        if (e.which == 13) {
          form.submit();
          return false;
        }
      });
    }

    if ($('#loginform')){
      enterOnSubmit($('#loginform'), $('#user_pass'));
    }

    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
      return false;
    };

    $(document).ready(function ($) {
      $('#passwordReset').on('submit', function (e) {
        e.preventDefault();

        const form = $(this);
        const email = $('#reset_password').val();
        const errorMessage = $('#val-mess');
        const successMessage = $('.pw-sent');

        // Clear previous messages
        errorMessage.hide();
        successMessage.hide();

        // Validate email
        if (!validateEmail(email)) {
          errorMessage.text('Please provide a valid email address.').show();
          return;
        }

        // AJAX request to handle_password_reset_request
        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          data: {
            action: 'handle_password_reset_request',
            reset_password: email,
          },
          success: function (response) {
            if (response.success) {
                    form.hide(); // Hide the form
                    successMessage.show(); // Show success message
                  } else {
                    errorMessage.text(response.data.message || 'An error occurred. Please try again.').show();
                  }
                },
                error: function () {
                  errorMessage.text('An unexpected error occurred. Please try again.').show();
                },
              });
      });

      function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      }
    });


    $(document).ready(function ($) {
      $('#form-reset-password').on('submit', function (e) {
        e.preventDefault();

        const form = $(this);
        const pass = $('input[name="pass"]').val();
        const passConfirm = $('input[name="confirmpass"]').val();
        const errorMessage = $('#errorMessages');

        // Clear previous messages
        errorMessage.html('');

        // Validate passwords
        if (!pass || !passConfirm) {
          errorMessage.html('<p style="color: red;">Both password fields are required.</p>');
          return;
        }
        if (pass !== passConfirm) {
          errorMessage.html('<p style="color: red;">Passwords do not match.</p>');
          return;
        }
        if (pass.length < 6) {
          errorMessage.html('<p style="color: red;">Password must be at least 6 characters long.</p>');
          return;
        }

        // AJAX request to do_password_reset
        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          data: {
            action: 'do_password_reset',
            rp_key: $('input[name="rp_key"]').val(),
            user_login: $('input[name="user_login"]').val(),
            pass: pass,
          },
          success: function (response) {
            if (response.success) {
              errorMessage.html('<p style="color: green;">Password successfully reset! Redirecting...</p>');
              setTimeout(function () {
                window.location.href =  '/?login=show';
              }, 3000);
            } else {
              errorMessage.html('<p style="color: red;">' + (response.data.message || 'An error occurred.') + '</p>');
            }
          },
          error: function () {
            errorMessage.html('<p style="color: red;">An unexpected error occurred. Please try again.</p>');
          },
        });
      });
    });





    $(document).on('click', '.submit__form', function (e) {
      e.preventDefault();
      if (!$(this).hasClass('disabled_form')) {
        if (document.querySelector('#passwordReset')) {
          if (validateEmail($('#reset_password').val())) {

            var email = $('#reset_password').val();
            $.ajax({
              url: ajaxurl + '?action=retrieve_password_ajax',
              type: 'post',
              data: { email: email },
              success: function (data) {
                $('.pw-sent').fadeIn()
              },
              error: function (jqXHR, textStatus, errorThrown) {
                console.log('AJAX error:', jqXHR, textStatus, errorThrown); // Debugging
              },
            });
          } else {
            console.log('Invalid email'); // Debugging
            $('#reset_password').addClass('invalid__email');
            $('.pwd__wrap').addClass('email__invalid');
          }
        }
      }
    });


    $(document).on('click', '.submit__reg', function(e) {
      e.preventDefault();
      console.log('submitted');

      var form = $(this).closest('.register__form'),
      email = form.find('[name="email"]').val(),
      passw = form.find('[name="pass"]').val(),
      consentChecked = form.find('[name="consent"]').is(':checked');

      console.log('Email:', email);

      let blockedDomains = [
      'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.co.uk', 'yahoo.co.in',
      'hotmail.com', 'hotmail.co.uk', 'outlook.com', 'outlook.co.uk', 'live.com', 'live.co.uk',
      'aol.com', 'icloud.com', 'me.com', 'mac.com', 'mail.com', 'protonmail.com',
      'zoho.com', 'yandex.com', 'yandex.ru', 'gmx.com', 'gmx.net', 'fastmail.com',
      'mail.ru', 'rambler.ru', 'inbox.ru', 'bk.ru', 'list.ru',
      'rediffmail.com', 'tutanota.com', 'hushmail.com', 'hotmail.fr', 'hotmail.de',
      'yahoo.fr', 'yahoo.de', 'yahoo.ca', 'yahoo.com.br', 'yahoo.co.jp',
      'lycos.com', 'rocketmail.com', 'mailinator.com', 'temp-mail.org', '10minutemail.com',
      't-online.de', 'web.de', 'qq.com', '163.com', '126.com', 'sina.com',
      'naver.com', 'daum.net', 'hanmail.net', 'kakao.com', 'tiscali.co.uk', 'bluewin.ch',
      'virgilio.it', 'libero.it', 'alice.it', 'bigpond.com', 'btinternet.com',
      'telstra.com', 'shaw.ca', 'rogers.com', 'sympatico.ca', 'cox.net',
      'earthlink.net', 'comcast.net', 'verizon.net', 'att.net', 'bellsouth.net',
      'charter.net', 'windstream.net', 'frontier.com', 'ntlworld.com', 'optusnet.com.au',
      'onet.pl', 'wp.pl', 'o2.pl', 'interia.pl', 'orange.fr', 'wanadoo.fr',
      'freemail.hu', 'seznam.cz', 'centrum.cz', 'volny.cz', 'mail.kz', 'mail.bg',
      'zoznam.sk', 'abv.bg', 'laposte.net', 'bigpond.net.au', 'bigpond.com.au',
      'sky.com', 'virginmedia.com', 'ntlworld.com', 'talktalk.net', 'sbcglobal.net',
      'optonline.net', 'comhem.se', 'bredband.net', 'spray.se', 'home.nl', 'ziggo.nl',
      'planet.nl', 'xs4all.nl', 'upcmail.nl', 'sol.dk', 'jubii.dk', 'get2net.dk',
      'suomi24.fi', 'elisanet.fi', 'dnainternet.net', 'luukku.com', 'mail.ee',
      ];

      // Function to extract domain and check if blocked
      function isBlockedEmail(email) {
        let emailDomain = email.includes('@') ? email.split('@')[1].toLowerCase() : '';
        return blockedDomains.includes(emailDomain);
      }

      // Email Validation
      if (email != '') {
        if (isBlockedEmail(email)) {
          console.log('Blocked email domain');
          form.find('[name="email"]').addClass('error');
          form.find('.error-text').html('Please enter your work email address').addClass('error');
          return;
        }
      } else {
        console.log('No email supplied');
        form.find('[name="email"]').addClass('error');
        form.find('[name="email"]').parent().find('.error-text').html('Please enter your work email address');
        return;
      }

      // Terms and Conditions Validation
      if (!consentChecked) {
        console.log('Terms not accepted');
        form.find('[name="consent"]').addClass('error');
        form.find('.consent-error').html('You must agree to the Terms and Conditions.').addClass('error');
        return;
      } else {
        form.find('[name="consent"]').removeClass('error');
        form.find('.consent-error').html(''); // Clear any previous errors
      }

      // Proceed if all validations pass
      if (validate_registration(form, true)) {
        let dataArray;
        $.ajax({
          url: ajaxurl + '?action=create_eb_account',
          type: 'post',
          data: { email: email },
          success: function(data) {
            dataArray = JSON.parse(data);
            console.log(dataArray);

            if (dataArray['error'] && dataArray['error'] !== '') {
              form.find('.form-error-box').html(dataArray['error']).addClass('error');
            } else if (dataArray['added'] == 'true') {
              // Optional: Perform immediate actions in success
              console.log('User added, processing complete function...');
            }
          },
          complete: function() {
            if (dataArray && dataArray['added'] == 'true') {
              // Append URL parameter and refresh the page
              const newUrl = window.location.origin + window.location.pathname + '?show_interests=true';
              window.location.href = newUrl;
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.log('AJAX error:', jqXHR);
          },
        });

        console.log('Checking cookies:', document.cookie);
      }
    });

      // Quiz Block
      $(document).ready(function () {
        const $desktopForm = $("#quiz-form");
        const $mobileForm = $("#quiz-form-mobile");
        const $profileForm = $("#quiz-form-profile");

        // Handle quiz navigation
        function initializeQuiz($form, $nextBtn, $prevBtn, $submitBtn) {
          const $questions = $form.find(".quiz-question");
          let currentQuestion = 0;

          function showQuestion(index) {
            $questions.each(function (i) {
                    $(this).toggle(i === index); // Show the current question, hide others
                  });
            if (index > 0) {
              $prevBtn.css("visibility", "visible");
            } else {
              $prevBtn.css("visibility", "hidden");
            }

            if (index < $questions.length - 1) {
              $nextBtn.css("visibility", "visible");
              $submitBtn.css("visibility", "hidden");
            } else {
              $nextBtn.css("visibility", "hidden");
              $submitBtn.css("visibility", "visible");
            }
          }

          $nextBtn.on("click", function () {
            const currentQuestionElement = $questions.eq(currentQuestion);
            const selectedOption = currentQuestionElement.find('input[type="radio"]:checked, input[type="checkbox"]:checked');

            if (!selectedOption.length) {
              alert("Please select an answer before proceeding."); // Show warning
              return; // Stop execution and do not move to the next question
            }
            if (currentQuestion < $questions.length - 1) {
              currentQuestion++;
              showQuestion(currentQuestion);
            }
          });

          $prevBtn.on("click", function () {
            if (currentQuestion > 0) {
              currentQuestion--;
              showQuestion(currentQuestion);
            }
          });

            // Initialize with the first question
            showQuestion(currentQuestion);
          }

        // Function to add 'selected' class to labels
        function initializeRadioButtons($form) {
          $form.find("label input[type='radio']").on("click", function () {
            const name = $(this).attr("name"); // Get the radio button group name

            // Remove 'selected' class from all labels in the same group
            $form.find(`input[name='${name}']`).closest("label").removeClass("selected");

            // Add 'selected' class to the label of the clicked radio button
            $(this).closest("label").addClass("selected");
          });
        }

        // Initialize desktop quiz
        initializeQuiz(
          $desktopForm,
          $("#next-btn"),
          $("#prev-btn"),
          $("#submit-btn")
          );
        initializeRadioButtons($desktopForm);

        // Initialize mobile quiz
        initializeQuiz(
          $mobileForm,
          $("#next-btn-mobile"),
          $("#prev-btn-mobile"),
          $("#submit-btn-mobile")
          );
        initializeRadioButtons($mobileForm);

        // Initialize profile quiz
        initializeQuiz(
          $profileForm,
          $("#next-btn-profile"),
          $("#prev-btn-profile"),
          $("#submit-btn-profile")
          );
        initializeRadioButtons($profileForm);

        // Ajax Quiz Submission

        const initializeQuizForm = (formId, prevBtnId, nextBtnId, successMessageSelector, isProfilePage = false) => {
          const quizForm = document.getElementById(formId);
          if (!quizForm) return;

          const questions = quizForm.querySelectorAll('.quiz-question');
          const prevBtn = document.getElementById(prevBtnId);
          const nextBtn = document.getElementById(nextBtnId);
          const quizCompleteMessage = document.querySelector(successMessageSelector);
          const totalQuestions = questions.length;
  let currentQuestionIndex = 0; // Tracks the current question index

  // Map to store answers by question ID
  const answersMap = {};

  const allQuestionsAnswered = () => {
    return Array.from(questions).every(
      question => question.getAttribute('data-answered') === 'true'
      );
  };

  const updateQuestionVisibility = () => {
    console.log(`Current Question Index: ${currentQuestionIndex}`); // Debugging
    if (allQuestionsAnswered() && !isProfilePage) {
      console.log('All questions answered for form:', formId);
      quizForm.style.display = 'none'; // Hide the quiz form
      quizCompleteMessage.style.display = 'block'; // Show the feedback message
      return; // Stop further execution
    }

    // Hide all questions except the current one
    questions.forEach((question, index) => {
      question.style.display = index === currentQuestionIndex ? '' : 'none';
    });

    // Update button visibility
    prevBtn.style.visibility = currentQuestionIndex === 0 ? 'hidden' : 'visible';
    nextBtn.textContent =
    isProfilePage && currentQuestionIndex === totalQuestions - 1
    ? 'Save'
    : currentQuestionIndex === totalQuestions - 1
    ? 'Finish'
    : 'Next';
    nextBtn.style.visibility = 'visible';
  };

  const submitCurrentQuestion = () => {
    const currentQuestion = questions[currentQuestionIndex];
    const selectedOption = currentQuestion.querySelector('input[type="radio"]:checked');
    const nonce = quizForm.getAttribute('data-nonce');
    const ajaxUrl = quizForm.getAttribute('data-ajax-url');
    const questionId = currentQuestion.getAttribute('id').replace('question-', '');
    const isLastQuestion = currentQuestion.getAttribute('data-last') === 'true';

    // Determine the answer: use the selected option or the saved answer
    const answer = selectedOption ? selectedOption.value : answersMap[questionId];
    if (!answer) {
      alert('Please select an answer before proceeding.');
      return Promise.resolve(false); // Prevent submission if no answer exists
    }

    const data = {
      action: 'submit_quiz_question',
      question_number: questionId,
      answer: answer, // Submit the current or saved answer
      nonce: nonce,
      is_last_question: isLastQuestion,
    };

    console.log('Sending data:', data);

    return fetch(ajaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data).toString(),
    })
    .then(response => response.json())
    .then(response => {
      if (response.success) {
        console.log(`Answer for question ${questionId} saved successfully.`);
        currentQuestion.setAttribute('data-answered', 'true');
          answersMap[questionId] = answer; // Update the saved answers
          return true;
        } else {
          console.error(
            `Error saving answer for question ${questionId}:`,
            (response.data && response.data.message) || 'Unknown error'
            );
          alert(
            (response.data && response.data.message) || 'An error occurred while saving your answer.'
            );
          return false;
        }
      })
    .catch(error => {
      console.error(`AJAX Error while saving question ${questionId}:`, error);
      alert('An error occurred while saving your answer. Please try again.');
      return false;
    });
  };

  nextBtn.addEventListener('click', () => {
    submitCurrentQuestion().then(isSubmitted => {
      if (isSubmitted) {
        if (currentQuestionIndex < totalQuestions - 1) {
          currentQuestionIndex++; // Move to the next question
          updateQuestionVisibility();
        } else if (allQuestionsAnswered()) {
          updateQuestionVisibility();
        }
      }
    });
  });

  prevBtn.addEventListener('click', () => {
    if (currentQuestionIndex > 0) {
      currentQuestionIndex--; // Move to the previous question
      updateQuestionVisibility();
    }

    // Restore selected answer for the previous question
    const currentQuestion = questions[currentQuestionIndex];
    const questionId = currentQuestion.getAttribute('id').replace('question-', '');
    if (answersMap[questionId]) {
      const radioButton = currentQuestion.querySelector(
        `input[type="radio"][value="${answersMap[questionId]}"]`
        );
      if (radioButton) radioButton.checked = true;
    }
  });

  // Initialize the quiz
  updateQuestionVisibility();
};




  // Function to initialize the appropriate form based on screen size
  const initializeFormsBasedOnScreenSize = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
      console.log('Screen size is mobile.');
      initializeQuizForm('quiz-form-mobile', 'prev-btn-mobile', 'next-btn-mobile', '#success-message-mobile');
    } else {
      console.log('Screen size is desktop.');
      initializeQuizForm('quiz-form', 'prev-btn', 'next-btn', '#success-message-desktop');
      initializeQuizForm('quiz-form-profile', 'prev-btn-profile', 'next-btn-profile', '#success-message-profile', true);
    }
  };

  // Run on initial load
  initializeFormsBasedOnScreenSize();

  // Add event listener for screen resize
  window.addEventListener('resize', () => {
    console.log('Screen resized.');
    initializeFormsBasedOnScreenSize();
  });
  
});

  //Interest AJAX
  const interestSubmitButton = document.getElementById('submitTopics');
  if (interestSubmitButton) {
    interestSubmitButton.addEventListener('click', function () {
      const currentUrl = window.location.href;
      const selectedTopics = Array.from(document.querySelectorAll('input[name="topics"]:checked')).map(input => input.value);

      if (selectedTopics.length === 0) {
        alert('Please select at least one topic.');
        return;
      }

      const form = document.querySelector('form[data-nonce]');

      function isVisible(element) {
        return element && element.offsetWidth > 0 && element.offsetHeight > 0;
      }

      jQuery.ajax({
        url: form.getAttribute('data-ajax-url'),
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'submit_interests',
          topics: selectedTopics,
        },
        success: function (response) {
          if (response.success) {

            // Display the success message
            const modalContent = document.querySelector('#modalTopics .title-section');
            const inPageContent = document.querySelector('.notifications-content .messages');

            if (modalContent && isVisible(modalContent)) {
              modalContent.innerHTML = `
              <p class="success-message" style="font-size: 1.2rem; text-align: center; margin-bottom: 1.5rem;">
              Your interests have been saved! This window will automatically close...
              </p>`;

              setTimeout(() => {
                const modalOverlay = document.getElementById('modalTopics');

                if (modalOverlay) {
                  modalOverlay.style.display = 'none';
                }

                window.location.href = currentUrl;

              }, 5000);
            }

            if (inPageContent) {
              inPageContent.innerHTML = `
              <p class="success-message" style="font-size: 1.2rem; text-align: center; margin-bottom: 1.5rem;">
              Your interests have been saved!
              </p>`;

              setTimeout(() => {
                inPageContent.style.display = 'none';
              }, 3000);
            }

          } else {
            console.error(response.data);
          }
        },
        error: function (xhr, status, error) {
          console.error('AJAX error:', status, error);
          alert('An error occurred. Please try again.');
        },
      });
    });
  }

  // Add class Interest

  const topicCards = document.querySelectorAll('.topic-card');

  topicCards.forEach(card => {
    card.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default checkbox behavior inside label
            
            const checkbox = this.querySelector('input[type="checkbox"]');

            if (checkbox) {
                checkbox.checked = !checkbox.checked; // Toggle
                this.classList.toggle('selected', checkbox.checked); // Toggle 'selected' class
              }
            });
  });

  // Quiz FORM
  jQuery(document).ready(function ($) {
    function updateCheckedState() {
      $('.gfield-choice-input').each(function () {
        if ($(this).is(':checked')) {
          $(this).parent().addClass('checked');
        } else {
          $(this).parent().removeClass('checked');
        }
      });
    }

    updateCheckedState();

    $(document).on('click', '.gform_next_button, .gform_previous_button', function () {
      setTimeout(updateCheckedState, 300);
    });

    $(document).on('change', '.gfield-choice-input', function () {
      const $input = $(this);
      const name = $input.attr('name');
      const type = $input.attr('type');

      if (type === 'radio') {
        $('input[name="' + name + '"]').parent().removeClass('checked');
        $input.parent().addClass('checked');

      } else if (type === 'checkbox') {
        if ($input.is(':checked')) {
          $input.parent().addClass('checked');
        } else {
          $input.parent().removeClass('checked');
        }
      }
    });


    // Ensure checked states are applied after Gravity Forms AJAX pagination
    $(document).on('gform_page_loaded', function () {
      updateCheckedState();
    });
  });

},
finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js